import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-asahlibraryscience',
  templateUrl: './asahlibraryscience.component.html',
  styleUrls: ['./asahlibraryscience.component.scss']
})
export class AsahlibraryscienceComponent implements OnInit {

  constructor() { }

    ngOnInit(): void {
        window.scrollTo(0, 0);
    }

}
